import React, { useState, useEffect, useRef, useContext } from "react";

import { t } from "i18next";
import CustomCheckBox from "../../../Hospital/components/HeaderFileChecks/CustomCheckBox";
import { TextField, PrimaryButton } from "@fluentui/react";
import { ACTIONS, USERTYPES } from "../../../../constants/Constants";
import themeContext from "../../../../context/theme/ThemeContext";

const OtherReportSettings = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errorState,
    firmGlobalErrorState,
    roles,
    action,
    ownFirm,
    isMinimalAccount,
    setFieldValue,
    editConfigurationSetting,
    signature2ImageValue,
    signature3ImageValue,
    handleClearImage,
    setIsSignatureFile2Deleted,
    setIsSignatureFile3Deleted,
  } = props;
  const { themeName, getThemeColor } = useContext(themeContext);

  const [enableShareReportLink, setEnableShareReportLink] = useState(
    values.enableShareReportLink
  );
  const [addSupervisorSignature, setAddSupervisorSignature] = useState(
    values.addSupervisorSignature
  );
  const [supervisor2Signtaure, setSupervisor2Signature] = useState(
    values.signature2Dto?.signatureFile2?.name
  );
  const [supervisor3Signtaure, setSupervisor3Signature] = useState(
    values.signature3Dto?.signatureFile3?.name
  );
  const [signature2Image, setSignature2Image] = useState(
    signature2ImageValue ? true : false
  );
  const [signature3Image, setSignature3Image] = useState(
    signature3ImageValue ? true : false
  );


  const allowedFileTypes = [".JPEG", ".jpeg", ".PNG", ".png", ".JPG", ".jpg"];

  
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    setEnableShareReportLink(values.enableShareReportLink);
  }, [values.enableShareReportLink]);

  useEffect(() => {
    setAddSupervisorSignature(values.addSupervisorSignature);
  }, [values.addSupervisorSignature]);

   useEffect(() => {
    if (!isMounted.current) return;  
    if (!addSupervisorSignature) {
      if (handleClearImage) handleClearImage("signature2");
      setSignature2Image(false);
      if (setFieldValue) {
        setFieldValue("signature2Dto.signatureFile2", null);
        setFieldValue("signature2Dto.isSignatureImageDeleted", 1);
      }
      if (setIsSignatureFile2Deleted) setIsSignatureFile2Deleted(true);
    }
  }, [addSupervisorSignature]);


  useEffect(() => {
    if (!isMounted.current) return;  
    if (!addSupervisorSignature) {
      if (handleClearImage) handleClearImage("signature3");
      setSignature3Image(false);
      if (setFieldValue) {
        setFieldValue("signature3Dto.signatureFile3", null);
        setFieldValue("signature3Dto.isSignatureImageDeleted", 1);
      }
      if (setIsSignatureFile3Deleted) setIsSignatureFile3Deleted(true);
    }
  }, [addSupervisorSignature])

  // const [addendumWorkflowEnabled, setAddendumWorkflowEnabled] = useState(props.values.addendumWorkflowEnabled);

   const [enableAddendumDisclaimerText, setEnableAddendumDisclaimerText] =
      useState(props.values.addendumDisclaimerEnabled);

  useEffect(() => {
    setEnableAddendumDisclaimerText(values.addendumDisclaimerEnabled);
  }, [values.addendumDisclaimerEnabled]);

  const showStudyLinkSettings =
    (action === ACTIONS.ADD && roles[0] === USERTYPES.ADMIN) ||
    (action === ACTIONS.EDIT &&(
      (roles[0] === USERTYPES.ADMIN && values.isMinimalAccount === 0) ||
      (roles[0] === USERTYPES.FIRMADMIN && ownFirm)));

        //remove this from here
  // const showSendReportNotification =
  //   roles[0] === USERTYPES.ADMIN ||
  //   ((roles[0] === USERTYPES.FIRMADMIN && ownFirm));

  const showSupervisorSignatures =
    roles[0] === USERTYPES.ADMIN ||
    ((roles[0] === USERTYPES.FIRMADMIN)|| roles[0] === USERTYPES.FIRMTECHNICIAN);

  // Check if we should show view mode for study link settings
  const showViewStudyLinkSettings =
    (ownFirm ||
      ((roles[0] === USERTYPES.ADMIN && values.isMinimalAccount === 0))) &&
    !values.isClientWarning;

  return (
    <>
      {/* EDIT MODE */}
      {(action === ACTIONS.ADD ||
        action === ACTIONS.EDIT ||
        editConfigurationSetting) && (
        <div className="tab-section">
          <section className="sectionA">
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.other-report-settings") || "Other Report Settings"}
            </p>
          </section>


          {/* 4. Include Reporting Date */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                {t("hospital.include-report-date")}
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={values.addDateToReport}
                  onChangeCustom={() => {
                    const newValue = !values.addDateToReport;
                    if (setFieldValue) {
                      setFieldValue("addDateToReport", newValue);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* 5. Include Reporting Time */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                {t("hospital.include-report-time")}
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={values.addTimeToReport}
                  onChangeCustom={() => {
                    const newValue = !values.addTimeToReport;
                    if (setFieldValue) {
                      setFieldValue("addTimeToReport", newValue);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* 6. Enable Addendum Workflow moved to Hospital Settings */}
          {/* {(roles[0] === USERTYPES.ADMIN &&
            (action === ACTIONS.ADD || action === ACTIONS.EDIT)) && (
            <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-addendum-workflow")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div style={{ marginTop: "5px" }}>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={values.addendumWorkflowEnabled}
                    onChangeCustom={() => {
                      const newValue = !values.addendumWorkflowEnabled;
                      setAddendumWorkflowEnabled(newValue);
                      if (setFieldValue) {
                        setFieldValue("addendumWorkflowEnabled", newValue);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )} */}

          {/* 6. Include Supervisor Signature */}
          <div style={{ display: "flex", maxHeight: "40px" }}>
            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
              <p className="single-line-form-field-key">
                Include Supervisor Signature
              </p>
            </div>
            <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
              <div style={{ marginTop: "5px" }}>
                <CustomCheckBox
                  parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                  values={values.addSupervisorSignature}
                  onChangeCustom={() => {
                    const newValue = !values.addSupervisorSignature;
                    setAddSupervisorSignature(newValue);
                    if (setFieldValue) {
                      setFieldValue("addSupervisorSignature", newValue);
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* SUPERVISOR SIGNATURES SECTION */}
          {addSupervisorSignature && showSupervisorSignatures && (
            <>
              <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Second Signature:</label>
                    <div>
                      {signature2ImageValue != null &&
                        signature2ImageValue != "" &&
                        signature2Image &&
                        values.signature2Dto?.isSignatureImageDeleted === 0 && (
                          <img
                            src={signature2ImageValue}
                            className="image-container-signature"
                            alt="Second signature"
                          />
                        )}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="signatureFile2"
                        type="file"
                        name="signatureFile2"
                        onChange={(ev) => {
                          if (addSupervisorSignature) {
                            setSupervisor2Signature(ev.target.files[0].name);
                            if (setFieldValue) {
                              setFieldValue("signature2Dto.signatureFile2", ev.target.files[0]);
                              setFieldValue("signature2Dto.isSignatureImageDeleted", 0);
                            }
                            if (setIsSignatureFile2Deleted) {
                              setIsSignatureFile2Deleted(false);
                            }
                            ev.target.value = null;
                          }
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      {!values.signature2Dto?.isSignatureImageDeleted && (
                        <label
                          style={{ marginLeft: "10px" }}
                          htmlFor="signatureFile2"
                        >
                          {supervisor2Signtaure}
                        </label>
                      )}
                      {((signature2ImageValue != null &&
                        signature2ImageValue != "" &&
                        signature2Image) ||
                        (supervisor2Signtaure != null &&
                          supervisor2Signtaure != "")) &&
                        values.signature2Dto?.isSignatureImageDeleted === 0 && (
                          <PrimaryButton
                            text="Clear Second Signature"
                            className="study-list-clear-all-button"
                            style={{ marginLeft: "5px", marginTop: "5px" }}
                            onClick={() => {
                              if (handleClearImage) {
                                handleClearImage("signature2");
                              }
                              setSignature2Image(false);
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>Third Signature:</label>
                    <div>
                      {signature3ImageValue != "" &&
                        signature3ImageValue != null &&
                        signature3Image &&
                        values.signature3Dto?.isSignatureImageDeleted === 0 && (
                          <img
                            src={signature3ImageValue}
                            className="image-container-signature"
                            alt="Third signature"
                          />
                        )}
                    </div>
                    <div>
                      <input
                        style={{ width: "112px", overflow: "hidden" }}
                        id="signatureFile3"
                        type="file"
                        name="signatureFile3"
                        onChange={(ev) => {
                          if (addSupervisorSignature) {
                            setSupervisor3Signature(ev.target.files[0].name);
                            if (setFieldValue) {
                              setFieldValue("signature3Dto.signatureFile3", ev.target.files[0]);
                              setFieldValue("signature3Dto.isSignatureImageDeleted", 0);
                            }
                            if (setIsSignatureFile3Deleted) {
                              setIsSignatureFile3Deleted(false);
                            }
                            ev.target.value = null;
                          }
                        }}
                        className="file-input-container"
                        accept={allowedFileTypes.join(",")}
                      />
                      {!values.signature3Dto?.isSignatureImageDeleted && (
                        <label
                          style={{ marginLeft: "10px" }}
                          htmlFor="signatureFile3"
                        >
                          {supervisor3Signtaure}
                        </label>
                      )}
                      {((signature3ImageValue != null &&
                        signature3ImageValue != "" &&
                        signature3Image) ||
                        (supervisor3Signtaure != null &&
                          supervisor3Signtaure != "")) &&
                        values.signature3Dto?.isSignatureImageDeleted === 0 && (
                          <PrimaryButton
                            text="Clear Third Signature"
                            className="study-list-clear-all-button"
                            style={{ marginLeft: "5px", marginTop: "5px" }}
                            onClick={() => {
                              if (handleClearImage) {
                                handleClearImage("signature3");
                              }
                              setSignature3Image(false);
                            }}
                          />
                        )}
                    </div>
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>{t("hospital.second-signature-text")}:</label>
                    <TextField
                      className="other-textArea"
                      styles={{
                        root: {
                          width: "40%",
                        },
                      }}
                      name="signature2Dto.signature2Text"
                      placeholder={t("hospital.second-signature-text")}
                      value={
                        values.signature2Dto?.signature2Text ??
                        values.signature2Dto?.signatureText ??
                        ""
                      }
                      onBlur={handleBlur}
                      onChange={handleChange}
                      errorMessage={
                        props.errorState?.otherReportSettings?.signature2Dto
                          ?.signature2Text?.error &&
                        props.errorState?.otherReportSettings?.signature2Dto
                          ?.signature2Text?.msg
                      }
                      resizable
                      multiline
                    />
                  </div>
                </div>
                <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                  <div
                    className="headerImageContainer"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <label>{t("hospital.third-signature-text")}: </label>
                    <TextField
                      className="other-textArea"
                      styles={{
                        root: {
                          width: "40%",
                        },
                      }}
                      name="signature3Dto.signature3Text"
                      placeholder={t("hospital.third-signature-text")}
                      value={
                        values.signature3Dto?.signature3Text ??
                        values.signature3Dto?.signatureText ??
                        ""
                      }
                      onBlur={handleBlur}
                      onChange={handleChange}
                      errorMessage={
                        props.errorState?.otherReportSettings?.signature3Dto
                          ?.signature3Text?.error &&
                        props.errorState?.otherReportSettings?.signature3Dto
                          ?.signature3Text?.msg
                      }
                      resizable
                      multiline
                    />
                  </div>
                </div>
              </div>
            </>
          )}
            {(props.roles[0] === USERTYPES.ADMIN ||
            props.roles[0] === USERTYPES.FIRMTECHNICIAN|| props.roles[0] === USERTYPES.FIRMADMIN) && (
            <>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <p className="single-line-form-field-key">
                      {t("hospital.enable-study-sharing")}
                    </p>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                    <div>
                      <CustomCheckBox
                        parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                        values={props.values.enableStudySharingLinkInReport}
                        onChangeCustom={() => {
                          const newValue = !props.values.enableStudySharingLinkInReport;
                          if (setFieldValue) {
                            setFieldValue("enableStudySharingLinkInReport", newValue);
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Send Report Submit Notification moved to Hospital Settings */}
          {/* {(props.roles[0] === USERTYPES.ADMIN || (props.roles[0] === USERTYPES.FIRMADMIN && props.ownFirm) )&& (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-send-report-submit-notification")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={props.values.sendReportSubmitNotification}
                    onChangeCustom={() => {
                      const newValue = !props.values.sendReportSubmitNotification;
                      if (setFieldValue) {
                        setFieldValue("sendReportSubmitNotification", newValue);
                      }
                    }}
          />
                  </div>
                </div>
              </div>
            </>
          )} */}

          {/* ENABLE DOWNLOAD REPORT */}
          {/* {props.roles[0] === USERTYPES.ADMIN && (
            <>
              <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.enable-download-report")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.allowDownloadReport}
                      onChangeCustom={() => {
                        props.values.allowDownloadReport =
                          !props.values.allowDownloadReport;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )} */}

          {/* ADDENDUM WORKFLOW ENABLED
          {(props.roles[0] === USERTYPES.FIRMADMIN || props.roles[0] === USERTYPES.ADMIN) && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  minHeight: "40px",
                  marginBottom: "0px",
                  marginTop: "5px",
                }}
              >
                <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                  <p className="single-line-form-field-key">
                    {t("hospital.addendum-workflow-enabled")}
                  </p>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                  <div>
                    <CustomCheckBox
                      parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                      values={props.values.addendumWorkflowEnabled}
                      onChangeCustom={() => {
                        setAddendumWorkflowEnabled((prev) => !prev);
                        props.values.addendumWorkflowEnabled = !props.values.addendumWorkflowEnabled;
                      }}
                    />
                  </div>
                </div>
              </div>
            </>
          )} */}


          {(props.roles[0] === USERTYPES.ADMIN ||
                      props.roles[0] === USERTYPES.FIRMTECHNICIAN ||
                      props.roles[0] === USERTYPES.FIRMADMIN) && (
                      <>
                        <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <p className="single-line-form-field-key">
                              {t("hospital.enable-addendum-disclaimer")}
                            </p>
                          </div>
                          <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                            <div>
                              <CustomCheckBox
                                parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                values={props.values.addendumDisclaimerEnabled}
                                onChangeCustom={() => {
                                  const newValue = !props.values.addendumDisclaimerEnabled;
                                  setEnableAddendumDisclaimerText(newValue);
                                  if (setFieldValue) {
                                    setFieldValue("addendumDisclaimerEnabled", newValue);
                                  }
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {enableAddendumDisclaimerText && (
                          <div style={{ display: "flex" }}>
                            <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                              <p className="single-line-form-field-key">
                                {t("hospital.addendum-disclaimer-text")}
                              </p>
                            </div>
                            <div
                              className="ms-Grid-col ms-sm12 ms-lg6 ms-xl6 single-line-form-field-value"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                marginTop: "5px",
                              }}
                            >
                              <TextField
                                styles={{
                                  root: {
                                    width: "100%",
                                  },
                                }}
                                name="addendumDisclaimerText"
                                placeholder={t("hospital.addendum-disclaimer-text")}
                                value={props.values.addendumDisclaimerText}
                                onBlur={props.handleBlur}
                                onChange={(e) => props.handleChange(e)}
                                resizable
                                multiline
                                errorMessage={
                                  props.errorState?.otherReportSettings?.addendumDisclaimerText?.error &&
                                  props.errorState?.otherReportSettings?.addendumDisclaimerText?.msg
                                }
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                     {/* ENABLE QR CODE IN REPORT */}
                              {(props.roles[0] === USERTYPES.ADMIN ||
                                props.roles[0] === USERTYPES.FIRMTECHNICIAN || props.roles[0] === USERTYPES.FIRMADMIN ) && (
                                <>
                                  <div style={{ display: "flex", flexDirection: "column" }}>
                                    <div style={{ display: "flex", alignItems: "center", minHeight: "40px", marginBottom: "0px" }}>
                                      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                                        <p className="single-line-form-field-key">
                                          {t("hospital.enable-qr-code")}
                                        </p>
                                      </div>
                                      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                                        <div>
                                          <CustomCheckBox
                                          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                                          values={props.values.enableQRCodeInReport}
                                          onChangeCustom={() => {
                                            const newValue = !props.values.enableQRCodeInReport;
                                            if (setFieldValue) {
                                              setFieldValue("enableQRCodeInReport", newValue);
                                            }
                                          }}
                                        />
                                        </div>
                                      </div>
                                    </div>
                                    
                                  </div>
                                </>
                              )}

                      {props.values.enableQRCodeInReport && (
                        <div style={{ display: "flex" }}>
                          <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                            <p className="single-line-form-field-key">
                              {t("hospital.qr-link-validity-time")}
                            </p>
                          </div>
                          <div
                            className="ms-Grid-col ms-sm6 ms-lg4 ms-xl4 single-line-form-field-value"
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <div style={{ marginLeft: "5px", marginBottom: "10px" }}>
                              <TextField
                                type="number"
                                name="qrLinkExpiryTime"
                                placeholder={t("hospital.qr-link-validity-time")}
                                value={props.values.qrLinkExpiryTime ?? ""}
                                styles={{
                                  root: {
                                    width: "200px",
                                  },
                                }}
                                onBlur={props.handleBlur}
                                onChange={(e) => {
                                  if (e.target.value.length > 5) return;
                                  props.handleChange(e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "." || e.key === "e" || e.key === "E") {
                                    e.preventDefault();
                                  }
                                }}
                                errorMessage={
                                  (props.errorState?.settings?.qrLinkExpiryTime?.error &&
                                    props.errorState?.settings?.qrLinkExpiryTime?.msg) ||
                                  props.firmGlobalErrorState?.qrLinkExpiryTime
                                }
                              />
                            </div>
                          </div>
                        </div>
                      )}

      {/* ADD FORMATS IN EMAIL */}
{(props.roles[0] === USERTYPES.ADMIN ||
  props.roles[0] === USERTYPES.FIRMADMIN) && (
  <>
    <div style={{ display: "flex", alignItems: "center", minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg12 ms-xl12">
        <p className="single-line-form-field-key" style={{ fontWeight: "600" }}>
          {t("hospital.add-formats-in-email")}
        </p>
      </div>
    </div>
    <div style={{ display: "flex", alignItems: "center", minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4" style={{ paddingLeft: "24px" }}>
        <p className="single-line-form-field-key">PDF</p>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
        <CustomCheckBox
          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
          values={props.values.emailPDF}
          onChangeCustom={() => {
            if (setFieldValue) setFieldValue("emailPDF", !props.values.emailPDF);
          }}
        />
      </div>
    </div>
    <div style={{ display: "flex", alignItems: "center", minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4" style={{ paddingLeft: "24px" }}>
        <p className="single-line-form-field-key">Docx</p>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
        <CustomCheckBox
          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
          values={props.values.emailDOCX}
          onChangeCustom={() => {
            if (setFieldValue) setFieldValue("emailDOCX", !props.values.emailDOCX);
          }}
        />
      </div>
    </div>
{props.errorState?.otherReportSettings?.emailFormat?.error && (
  <div
    style={{
      paddingLeft: "24px",
      marginTop: "4px",
      fontFamily:
        '"Segoe UI", "Segoe UI Web (West European)", sans-serif',
      fontSize: "12px",
      fontWeight: 700,
      color: "red",
    }}
  >
    {props.errorState.otherReportSettings.emailFormat.msg}
  </div>
)}
    {/* {props.errorState?.otherReportSettings?.emailFormat?.error && (
      <span style={{ display: "block", paddingLeft: "24px", paddingTop: 5, fontSize: 12, lineHeight: "12px", color: "#a4262c", fontWeight: 400, margin: 0 }}>
        {props.errorState.otherReportSettings.emailFormat.msg}
      </span>
    )} */}
    {/* <div style={{ display: "flex", alignItems: "center", minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4" style={{ paddingLeft: "24px" }}>
        <p className="single-line-form-field-key">Doc</p>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
        <CustomCheckBox
          parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
          values={props.values.emailDOC}
          onChangeCustom={() => {
            if (setFieldValue) setFieldValue("emailDOC", !props.values.emailDOC);
          }}
        />
      </div>
    </div> */}
  </>
)}

          {/* 7. Send Report Submit Notification */}
          {/* {showSendReportNotification && (
            <div style={{ display: "flex", maxHeight: "40px" }}>
              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                <p className="single-line-form-field-key">
                  {t("hospital.enable-send-report-submit-notification")}
                </p>
              </div>
              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl6 single-line-form-field-value">
                <div>
                  <CustomCheckBox
                    parentClassName="form-field ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl12"
                    values={values.sendReportSubmitNotification}
                    onChangeCustom={() => {
                      const newValue = !values.sendReportSubmitNotification;
                      if (setFieldValue) {
                        setFieldValue("sendReportSubmitNotification", newValue);
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          )} */}
        </div>
      )}

      {/* VIEW MODE */}
      {action === ACTIONS.VIEW && !editConfigurationSetting && (
        <div className="tab-section">
          <section className="sectionA" style={{ marginBottom: "1rem" }}>
            <p
              style={{
                fontSize: "22px",
                fontWeight: "600",
                padding: "0px 0px",
              }}
            >
              {t("hospital.other-report-settings") || "Other Report Settings"}
            </p>
          </section>
          <div className="ms-Grid" dir="ltr">

                {/* Enable Share Report Link - View */}
                {!editConfigurationSetting &&
                  !values.isClientWarning &&
                  roles[0] !== USERTYPES.FIRMDOCTOR && (
                    <>

                  {/* Include Reporting Date - View */}
                  <div className="ms-Grid-row" style={{ display: "flex", minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.include-report-date")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div>{values.addDateToReport ? "Yes" : "No"}</div>
                    </div>
                  </div>

                  {/* Include Reporting Time - View */}
                  <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div className="form-heading">
                        {t("hospital.include-report-time")}
                      </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                      <div>{values.addTimeToReport ? "Yes" : "No"}</div>
                    </div>
                  </div>
                </>
              )}

            {/* Include Supervisor Signature - View */}
            {(roles[0] === USERTYPES.ADMIN ||
              (roles[0] === USERTYPES.FIRMADMIN)|| roles[0] === USERTYPES.FIRMTECHNICIAN) && (
              <>
                <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div className="form-heading">
                      Include Supervisor Signature
                    </div>
                  </div>
                  <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                    <div>
                      {values.addSupervisorSignature ? "Yes" : "No"}
                    </div>
                  </div>
                </div>

                {/* Supervisor Signatures - View */}
                {values.addSupervisorSignature && (
                  <>
                    <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>Second Signature:</label>
                          <div>
                            {signature2ImageValue !== "" && signature2ImageValue != null ? (
                              <img
                                src={signature2ImageValue}
                                className="image-container-signature"
                                alt="Signature not available"
                              />
                            ) : (
                              <div>{t("hospital.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>Third Signature:</label>
                          <div>
                            {signature3ImageValue !== "" && signature3ImageValue != null ? (
                              <img
                                src={signature3ImageValue}
                                alt="Signature not available"
                                className="image-container-signature"
                              />
                            ) : (
                              <div>{t("hospital.no-image-found")}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: "flex", width: "95%", padding: "2.5%" }}>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{t("hospital.second-signature-text")}:</label>
                          <span>{values.signature2Dto?.signatureText}</span>
                        </div>
                      </div>
                      <div className="form-field flex flex-row ms-Grid-col ms-sm12 ms-md8 ms-lg6 ms-xl6">
                        <div
                          className="headerImageContainer"
                          style={{ display: "flex", flexDirection: "column" }}
                        >
                          <label>{t("hospital.third-signature-text")}: </label>
                          <span>{values.signature3Dto?.signatureText}</span>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
             {(props.roles[0] === USERTYPES.ADMIN ||
                          props.roles[0] === USERTYPES.FIRMTECHNICIAN || props.roles[0] === USERTYPES.FIRMADMIN) && (
                          <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                              <div className="form-heading">
                                {t("hospital.enable-study-sharing")}
                              </div>
                            </div>
                            <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                              <div>
                                {props.values.enableStudySharingLinkInReport ? "Yes" : "No"}
                              </div>
                            </div>
                          </div>
                  )}
            {/* Send Report Submit Notification - View moved to Hospital Settings */}
            {/* {showSendReportNotification && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-send-report-submit-notification")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{values.sendReportSubmitNotification ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}

            {/* Enable Download Report - View */}
            {/* {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-download-report")}
                  </div>
                </div>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.allowDownloadReport ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}

            {/* ENABLE ADDENDUM WORKFLOW - View */}
            {/* {props.roles[0] === USERTYPES.ADMIN && (
              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                  <div className="form-heading">
                    {t("hospital.enable-addendum-workflow")}
                  </div>
                </div>
                <div id="enable-addendum-workflow-value" className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                  <div>{props.values.addendumWorkflowEnabled ? "Yes" : "No"}</div>
                </div>
              </div>
            )} */}

            {(props.roles[0] === USERTYPES.ADMIN ||
                          props.roles[0] === USERTYPES.FIRMDOCTOR ||
                          props.roles[0] === USERTYPES.FIRMTECHNICIAN ||
                          (props.roles[0] === USERTYPES.FIRMADMIN)) && (
                          <>
                            <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                              <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
                                <div className="form-heading">
                                  {t("hospital.enable-addendum-disclaimer")}
                                </div>
                              </div>
                              <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl4">
                                <div>
                                  {props.values.addendumDisclaimerEnabled ? "Yes" : "No"}
                                </div>
                              </div>
                            </div>
                            {!!enableAddendumDisclaimerText && (
                              <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                                  <div className="form-heading">
                                    {t("hospital.addendum-disclaimer-text")}
                                  </div>
                                </div>
                                <div className="ms-Grid-col ms-sm12 ms-md8 ms-lg4 ms-xl4">
                                  <div>
                                    {props.values.addendumDisclaimerText
                                      ? props.values.addendumDisclaimerText
                                      : ""}
                                  </div>
                                </div>
                              </div>
                            )}
                          </>
                        )}

                        {/* ENABLE QR CODE REPORT */}
                                    {(props.roles[0] === USERTYPES.ADMIN ||
                                      props.roles[0] === USERTYPES.FIRMTECHNICIAN ||  props.roles[0] === USERTYPES.FIRMADMIN ) && (
                                      <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                                          <div className="form-heading">
                                            {t("hospital.enable-qr-code")}
                                          </div>
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                                          <div>{props.values.enableQRCodeInReport ? "Yes" : "No"}</div>
                                        </div>
                                      </div>
                                    )}

                                    {props.values.enableQRCodeInReport && (
                                      <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
                                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg4 ms-xl4">
                                          <div className="form-heading">
                                            {t("hospital.qr-link-validity-time")}
                                          </div>
                                        </div>
                                        <div className="ms-Grid-col ms-sm12 ms-md6 ms-lg8 ms-xl8">
                                          <div>
                                            {props.values.qrLinkExpiryTime ? props.values.qrLinkExpiryTime : "0"}
                                          </div>
                                        </div>
                                      </div>
                                    )}

 {(props.roles[0] === USERTYPES.ADMIN ||
  props.roles[0] === USERTYPES.FIRMADMIN) && (
  <>
    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
        <div className="form-heading">
          {t("hospital.add-formats-in-email")}
        </div>
      </div>
    </div>
    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
        <div className="form-heading" style={{ paddingLeft: "24px" }}>
          PDF
        </div>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
        {props.values.emailPDF ? "Yes" : "No"}
      </div>
    </div>
    <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
        <div className="form-heading" style={{ paddingLeft: "24px" }}>
          Docx
        </div>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
        {props.values.emailDOCX ? "Yes" : "No"}
      </div>
    </div>
    {/* <div className="ms-Grid-row" style={{ minHeight: "40px" }}>
      <div className="ms-Grid-col ms-sm12 ms-lg4 ms-xl4">
        <div className="form-heading" style={{ paddingLeft: "24px" }}>
          Doc
        </div>
      </div>
      <div className="ms-Grid-col ms-sm12 ms-lg8 ms-xl8">
        {props.values.emailDOC ? "Yes" : "No"}
      </div>
    </div> */}
  </>
)}
          </div>
        </div>
      )}
    </>
  );
};

export default OtherReportSettings;